<div>
  <kl-fpo-infrastructure-form (closeDialog)="ok()"></kl-fpo-infrastructure-form>
</div>
